






























































// @ is an alias to /src
import Vue from 'vue';
import ApiRequest from '@/util/apiRequest';

import { API_MOTION_QUERY } from '@/util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      motionText: undefined,
      motion: undefined,
    };
  },
  components: {
  },
  methods: {
    async load(nextRoute) {
      try {
        const response = await ApiRequest.Get(API_MOTION_QUERY + nextRoute.params.id);
        this.$data.motion = response;
        this.$data.motionText = response.text;
      } catch (error) {
        if (error.statusCode === 404) {
          this.$data.motionName = 'Not Found';
        } else {
          throw error;
        }
      }
    },
    isLastTag(tagNumInList) {
      return tagNumInList === this.motion.tags.length - 1;
    },
    getLanguage() {
      switch (this.$data.motion.language) {
        case 'en':
          return 'English';
        default:
          return this.$data.motion.language;
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.load(to);
    next();
  },
  computed: {
  },
  mounted() {
    this.load(this.$route);
  },
});
